import * as React from 'react';
import { Helmet } from 'react-helmet';
import { Footer, Header, LeadManager } from '@sky-tv-group/components';
import { useAuth0, getUser } from './store/authStore/authStore';
import useStore from './store';

import { Home, Page, ErrorPage,NewSkyPodPage } from './templates'
import {
  createBrowserRouter,
  RouterProvider,
  Navigate
} from "react-router-dom";
import { BACKEND_ENDPOINT } from '@sky-tv-group/shared';


const App = () => {
  const logout = useAuth0(s => s.logout);
  const login = useAuth0(s => s.login);
  const { isAuthenticated } = useAuth0();
  const navLinks = useStore(s => s.navLinks);
  const userData = getUser();
  const fetchNavLinks = useStore(s => s.fetchNavLinks);
  const logoutHandler = async () => {
    logout();
  };
 
  React.useEffect(() => {
    fetchNavLinks();
  }, [fetchNavLinks]);

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Navigate to="/products" replace />,
      errorElement: <ErrorPage  />,
    },
    {
      path: "/products",
      element: <Home />,
      errorElement: <ErrorPage  />,
    },
    {
      path: "/products/sky-pod",
      element: <NewSkyPodPage />,
      errorElement: <ErrorPage  />,
    },
    {
      path: "/products/:product",
      element: <Page />,
      errorElement: <ErrorPage  />,
    },
    {
      path: "/products/:product/:page",
      element: <Page />,
      errorElement: <ErrorPage  />,
    },
  ]);

  return (
    <>
      <Header
        isSignedIn={isAuthenticated}
        name={userData?.nickname || userData?.given_name}
        SessionClickHandler={isAuthenticated ? logoutHandler : login}
        links={navLinks}
      />
      <RouterProvider router={router} />
      <LeadManager apiEndpoint={BACKEND_ENDPOINT} isSignedIn={isAuthenticated}/>
      <Footer links={navLinks} />
    </>
  );
};

export default App;
